import React, { useState, useEffect } from 'react';
import { getApi } from '../../api/endpoints.js';
import {useParams, useNavigate} from 'react-router-dom'
import Technician from '../../models/Technician'
import { toast } from 'react-toastify';
import FormPartial from './FormPartial.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";

const Edit = () => {
  const navigate = useNavigate();
  const params = useParams();
  let technicianObj = new Technician({service_center_id: params.service_center_id});
  const [technician, setTechnician] = useState(technicianObj.toStateJson());
  const [updateApi] = getApi('updateTechnician');
  const [showApi] = getApi('showTechnician');

  useEffect(()=>{
    setTechnicianObj();
  }, [])

  const setTechnicianObj = async () => {
    try {
      const response = await showApi({id: params.id}).unwrap();
      setTechnician(new Technician(response.data.technician).toStateJson());
    } catch (error) {
      toast.error(error.data?.message || "something went wrong")
    }
  }

  const udpateRecord = async (parameters) => {
    try {
      await updateApi(parameters).unwrap();
      toast.success("Technician updated Successfully")
      navigate( `/service_centers/${params.service_center_id}`)
    } catch (error) {
      toast.error(error.data?.message)
      technicianObj.set_api_errors(error.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      udpateRecord((new Technician(technician)).toApiJson());
    } catch(error){
      setTechnician(new Technician(technician));
    }
  }

  const handleCancelFunction = () => {
    navigate(`/service_centers/${params.service_center_id}`);
  }

  return <PageContentWrapper contentHeading={"Update Technician"}>
    <div className='m-3'>
      <div className='mb-4 col-md-12'>
        <form className="row g-3" autoComplete="off">
          <FormPartial technician={technician} setTechnician={setTechnician} />
          <div className='mb-4 col-md-12'>
            <div >
              <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Update Technician</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </PageContentWrapper>
};

export default Edit;

